import React from "react";
import { Navigate } from "react-router-dom";
import { routes } from "../../constants";

// The Impact Register is a tab on the project page now, so every URL that used
// to reach it standalone lands on the projects list:
//
//   /impacts                                            (the retired picker)
//   /impacts/<reportId>                                 (the standalone workspace)
//   /impact-register/<reportId>[/new|/<impactId>/edit]  (Task 3's register)
//   /stakeholder-groups/<reportId>[/new|/<groupId>/edit] (the standalone Groups screen)
//       -> /projects
//
// Deliberately NOT translated into a specific project. The Register was keyed by
// report; it is keyed by project now, and one report does not determine one
// project — a report can sit in several waves and a wave-less report in none at
// all. Guessing would sometimes open the wrong programme's Register, which is
// worse than the projects list, where one click gets it right.
export default function LegacyWorkspaceRedirect() {
    return <Navigate to={routes.projects} replace />;
}
